import { render, staticRenderFns } from "./ShortBagInfo.vue?vue&type=template&id=bfd71ba0&scoped=true&"
import script from "./ShortBagInfo.vue?vue&type=script&lang=js&"
export * from "./ShortBagInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShortBagInfo.vue?vue&type=style&index=0&id=bfd71ba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd71ba0",
  null
  
)

export default component.exports